import { render } from "./ElectionPolicyView.vue?vue&type=template&id=d20a4dca"
import script from "./ElectionPolicyView.vue?vue&type=script&lang=js"
export * from "./ElectionPolicyView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__